import {toArray} from 'lodash';
import axios from 'axios';

(() => {
  const changeEvent = document.createEvent('Event');
  changeEvent.initEvent('change', true, true);

  document.addEventListener('change', e => {
    const elem = e.target;

    switch (true) {
    default: 
      break;
      
    case elem.matches('input[name="payment"]'):
      if (elem.checked) {
        toArray(document.querySelectorAll('input[name="preset"]:checked'))
          .forEach(elem => elem.checked = false);
      }
      break;
      
    case elem.matches('input[name="preset"]'):
      if (elem.checked) {
        toArray(document.querySelectorAll('input[name="payment"]:checked'))
          .forEach(elem => {
            elem.checked = false;
            elem.dispatchEvent(changeEvent);
          });
      }
      break;
    }
  });

  function increaseTimeout( timeout ) {
    if ( timeout >= 5000 ) {
      return timeout;
    }
    return timeout * 2;
  }

  let timeout = 100;
  let checkPaymentStatus = () => {
    if (
      !window.routes ||
      !window.routes.checkPaymentStatus ||
      !window.routes.checkPaymentStatus[0]
    ) {
      return;
    }

    axios({
      method: 'get',
      url: window.routes.checkPaymentStatus[0],
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(res => {
      if (res.data.url) {
        window.location.href = res.data.url;
      } else {
        timeout = increaseTimeout(timeout);
        window.setTimeout(checkPaymentStatus, timeout);
      }
    }).catch(error => {
      timeout = increaseTimeout(timeout);
      window.setTimeout(checkPaymentStatus, timeout);
    });
  };
  document.addEventListener('DOMContentLoaded', checkPaymentStatus);
})();
